// MapPage.js
import React, { useEffect, useState } from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import IframeMap from '../../components/map/iframeMap';
import { useAuth } from '../../context/DBContext'; 
import { Layout, Spin, Row, Col, Select, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid'

const MapPage = () => {
    const { currentUser, getUserInfo } = useAuth();
    const [userCoordinates, setUserCoordinates] = useState({ latitude: null, longitude: null });
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
         // Check if the page has been reloaded before, to prevent infinite reload loops
        //  if (!sessionStorage.getItem('reloaded')) {
        //     sessionStorage.setItem('reloaded', 'true');
        //     window.location.reload(); // Reloads the page when first arriving on the map page
        // }

        const fetchCoordinates = async () => {
            if (currentUser) {
                try {
                    const userInfo = await getUserInfo(currentUser.uid);
                    if (userInfo && userInfo.latitude && userInfo.longitude) {
                        const coords = {
                            latitude: parseFloat(userInfo.latitude),
                            longitude: parseFloat(userInfo.longitude)
                        };
                        
                        // Validate coordinates
                        if (!isNaN(coords.latitude) && !isNaN(coords.longitude) && 
                            coords.latitude >= -90 && coords.latitude <= 90 &&
                            coords.longitude >= -180 && coords.longitude <= 180) {
                            setUserCoordinates(coords);
                        } else {
                            setUserCoordinates({
                                latitude: 51.5072,
                                longitude: 0.1276
                            });
                        }
                    } else {
                        // Fallback coordinates if user info is missing
                        setUserCoordinates({
                            latitude: 51.5072, // Default latitude
                            longitude: 0.1276 // Default longitude
                        });
                    }
                } catch (error) {
                    // Fallback coordinates in case of error
                    setUserCoordinates({
                        latitude: 51.5072,
                        longitude: 0.1276
                    });
                }
            } else {
                // Fallback coordinates if no user is logged in
                setUserCoordinates({
                    latitude: 51.5072,
                    longitude: 0.1276
                });
            }
            setLoading(false);
        };

        fetchCoordinates();
        navigate('/map');
    }, [currentUser, getUserInfo]);

    if (loading) {
        return (
            <>
                {/* Optionally, display a spinner or placeholder */}
                {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    </div> */}
            </>
        );
    }

    // Don't render the map until we have valid coordinates
    if (userCoordinates.latitude === null || userCoordinates.longitude === null) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>
        );
    }

    return (
        <>
        
            {/* Main Content */}
            <section>
           
                <IframeMap 
                    latitude={userCoordinates.latitude} 
                    longitude={userCoordinates.longitude} 
                />
            </section>
        </>
    );
}

export default MapPage;
